module.exports = __webpack_public_path__ + "static/media/autopilot-mode-large@3x.be477d50.png";